import React, { useState, useEffect } from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const [policyText, setPolicyText] = useState("Loading policy...");

  useEffect(() => {
    // Fetch the content from your live GoDaddy URL
    fetch('https://atrmart.in/Privacy-Policy.txt')
      .then(response => response.text())
      .then(data => {
        setPolicyText(data);
      })
      .catch(err => {
        console.error("Failed to load policy:", err);
        setPolicyText("Unable to load Privacy Policy. Please contact support@atrmart.in");
      });
  }, []);

  return (
    <div className="policy-container">
      <header className="policy-header">
        <h1>Privacy Policy</h1>
        <p>ATR AGRO MART | Official Documentation</p>
      </header>

      <section className="policy-content">
        {/* whiteSpace: 'pre-wrap' ensures that your line breaks from the .txt file are kept */}
        <div style={{ whiteSpace: 'pre-wrap', fontSize: '1rem', color: '#333' }}>
          {policyText}
        </div>
      </section>

      <div className="policy-footer-info">
        <h3>Contact Us:</h3>
        <p>ATR MART</p>
        <p>12A, Vaigai Nagar 2nd Street,</p>
        <p>Madurai, 625017</p>
        <p><strong>Contact:</strong> +91 93444 53444</p>
        <p><strong>Email:</strong> support@atrmart.in</p>
      </div>
    </div>
  );
};
export default PrivacyPolicy;